import { Paper } from '@mui/material';
import { PageLayout, SuspenseWithSentryErrorBoundary } from '@retail/components';
import { ExportContainer } from '@retail/export/containers';

export function ExportPage() {
  return (
    <PageLayout maxWidth="full" fixedHeight spacing={2}>
      <Paper sx={{ display: 'flex', overflow: 'hidden', height: '100%' }}>
        <SuspenseWithSentryErrorBoundary>
          <ExportContainer />
        </SuspenseWithSentryErrorBoundary>
      </Paper>
    </PageLayout>
  );
}
